// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2urDY","calendarButtons":"ClockData_calendarButtons__2Yo5P"};